import { render, staticRenderFns } from "./DomainViewers.vue?vue&type=template&id=2322a5da&"
import script from "./DomainViewers.vue?vue&type=script&lang=js&"
export * from "./DomainViewers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports